import { css } from "styled-components";
export const sizes = {
  tiny: css(["height:25px;padding:0 10px;line-height:25px;"]),
  small: css(["height:32px;padding:0 10px;line-height:32px;"]),
  default: css(["height:42px;padding:0 15px;line-height:42px;"])
};
export default function size({
  size
}) {
  return sizes[size] || sizes.default;
}
//# sourceMappingURL=size.js.map